export const useTimeouts = (time = 100) => {
	return new Promise(resolve => {
		const timeout = setTimeout(() => {
			resolve(true)
			clearTimeout(timeout)
		}, time)
	})
}
